import React from "react";
import { CheckCircle2, Sparkles } from "lucide-react";
import CTAButton from "./CTAButton";

const STACK = [
  {
    title: "Live AI Money Machine Training",
    desc: "Full 90-minute live implementation workshop with Nawaz Shaikh.",
    editable: false,
  },
  {
    title: "Expert Positioning Framework",
    desc: "Walk out with a clearer positioning story premium buyers can actually understand.",
    editable: false,
  },
  {
    title: "Authority Content System",
    desc: "The exact content architecture behind high-authority expert brands.",
    editable: false,
  },
  {
    title: "Client-Acquisition Roadmap",
    desc: "Map the journey from first impression to premium client, step by step.",
    editable: false,
  },
  {
    title: "Live ViralX Demonstration",
    desc: "See the AI operating system running inside a real content workflow.",
    editable: false,
  },
  {
    title: "Live Q&A With Nawaz Shaikh",
    desc: "Bring your specific niche, offer and situation. Ask directly, live.",
    editable: true,
    note: "Include only if Q&A is genuinely part of the live session.",
  },
];

export default function ValueStack() {
  return (
    <section className="relative z-10 px-4 py-10 md:py-14">
      <div className="max-w-4xl mx-auto">
        <p className="text-center text-[#C4FF3D] uppercase tracking-[0.28em] text-[11px] md:text-xs font-bold mb-3">
          What's Included
        </p>
        <h2 className="display-font text-center text-3xl md:text-5xl font-extrabold leading-tight mb-4">
          <span className="text-white">A Full Implementation Workshop For</span>{" "}
          <span className="lime-box">₹199.</span>
        </h2>
        <p className="text-center text-white/65 max-w-2xl mx-auto mb-10">
          Not a webinar full of theory. A working session designed to install real systems into your business.
        </p>

        <div className="rounded-3xl border border-[rgba(196,255,61,0.28)] bg-gradient-to-b from-[#0e1410] to-[#0a0f0a] p-6 md:p-8">
          <ul className="divide-y divide-dashed divide-[rgba(196,255,61,0.15)]">
            {STACK.map((it) => (
              <li key={it.title} className="py-4 flex items-start gap-4">
                <CheckCircle2 className="w-6 h-6 text-[#C4FF3D] shrink-0 mt-0.5" />
                <div className="flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-white font-bold text-base md:text-lg">{it.title}</span>
                    {it.editable && (
                      <span className="badge-pulse relative inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-[#C4FF3D] border border-[#C4FF3D]/50 rounded px-2 py-1 bg-[rgba(196,255,61,0.06)] font-bold">
                        <span className="relative flex h-1.5 w-1.5">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#C4FF3D] opacity-75" />
                          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#C4FF3D]" />
                        </span>
                        Confirm Inclusion
                      </span>
                    )}
                  </div>
                  <p className="text-white/65 text-sm md:text-[15px] leading-relaxed mt-1">{it.desc}</p>
                </div>
              </li>
            ))}
          </ul>

          <div className="mt-8 pt-6 border-t border-dashed border-[rgba(196,255,61,0.2)] text-center">
            <div className="flex items-center justify-center gap-2 text-white/60 text-xs md:text-sm uppercase tracking-[0.2em] font-semibold mb-2">
              <Sparkles className="w-3.5 h-3.5 text-[#C4FF3D]" />
              Today's Registration
            </div>
            <div className="display-font text-5xl md:text-6xl font-extrabold text-[#C4FF3D] mb-6">
              ₹199
            </div>
            <div className="flex justify-center">
              <CTAButton source="value_stack" size="lg">
                Unlock My Seat For ₹199
              </CTAButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
